module.exports = __webpack_public_path__ + "media/flags/et-8e565b59.svg";